<section id="main">
  <div class="container-fluid">
    <div class="row domp-header-wrapper">
      <div class="domp-header-row col-md-12">
        <h2 ng-if="investment.model.orderType == 1" class="intp-title" translate="investOverview.buyStocks">Buy stocks</h2>
        <h2 ng-if="investment.model.orderType == 2" class="intp-title" translate="investOverview.sellStocks">Sell stock</h2>
        <h2 ng-if="investment.model.orderType == 3" class="intp-title" translate="investOverview.replaceStocks">Replace stock</h2>
      </div>
    </div>
    <div class="m-b-30">
      <ui-view/>
    </div>
  </div>
</section>